export class EnrollmentCountModel {
    PlanName: string = ''
    PlanID?: number = 0
    TierTranslation?: string = ''
    Submitted: number = 0
    Cancelled: number = 0
    Disenrolled: number = 0
    Enrolled: number = 0
    Pending: number = 0
    Denied: number = 0
    CorrectionNeeded: number = 0
    Message?: string = ''
    StateAbbr?: string = ''
}
